import { BiPulse } from "react-icons/bi";
import { BsFillHouseFill } from "react-icons/bs";


const MenuList = [
    {
      id: 1,
      icon: <BsFillHouseFill />,
      name: "Home",
      path: "/user-home",
    },
    {
      id: 2,
      icon: <BiPulse />,
      name: "Logout",
    },
  ];
  
  export { MenuList };

